import React from "react";

import styled from "styled-components/macro";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { useIsSignupClosed } from "Signups/SharedComponents/useIsSignupClosed";

import { FnrPopover } from "UI/FnrPopover2";

import HoverButton from "../HoverButton";

import AddAdditionalNamePopover from "./AddAdditionalNamePopover";
import AddHouseholdMemberPopover from "./AddHouseholdMemberPopover";

export default function AddRespondent({
  isHovering,
  userID,
  showAddPopover, // null, "household", "additionalName"
  setShowAddPopover,
  householdID,
  signupItemID,
}) {
  const { isClosed, isArchived } = useIsSignupClosed();
  const placementRef = React.useRef();
  const showHouseholdPopover = showAddPopover === "household";
  const showAdditionalNamePopover = showAddPopover === "additionalName";

  const getClosedContent = () => {
    if (isArchived)
      return "This signup is currently archived. To add new respondents, please unarchive it.";
    return "This signup is currently expired. To add new respondents, please adjust the expiration date.";
  };

  const handlePlusButtonClick = () => {
    if (showAddPopover) setShowAddPopover(null);
    else if (householdID) setShowAddPopover("household");
    else setShowAddPopover("additionalName");
  };

  return (
    <Wrapper ref={placementRef}>
      <HoverButton
        icon={faPlusCircle}
        isHovering={isHovering}
        isActive={Boolean(showAddPopover)}
        onClick={handlePlusButtonClick}
      />

      <FnrPopover
        show={showAddPopover === "household"}
        buttonRef={placementRef}
        onShouldClose={() => setShowAddPopover(null)}
      >
        {isClosed ? (
          <Closed>{getClosedContent()}</Closed>
        ) : (
          <AddHouseholdMemberPopover
            show={showHouseholdPopover}
            householdID={householdID}
            signupItemID={signupItemID}
            handleSomeoneElseClick={() => setShowAddPopover("additionalName")}
            closePopover={() => setShowAddPopover(null)}
          />
        )}
      </FnrPopover>

      <FnrPopover
        show={showAddPopover === "additionalName"}
        buttonRef={placementRef}
        onShouldClose={() => setShowAddPopover(null)}
      >
        {isClosed ? (
          <Closed>{getClosedContent()}</Closed>
        ) : (
          <AddAdditionalNamePopover
            show={showAdditionalNamePopover}
            userID={userID}
            householdID={householdID}
            signupItemID={signupItemID}
            closePopover={() => setShowAddPopover(null)}
          />
        )}
      </FnrPopover>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Closed = styled.div`
  width: 200px;
  padding: 5px 10px;
  font-size: 15px;
`;
